import { DocumentVersionUpdateInfo, FolderItemStatus } from 'src/state/redux/selector/folder';
import { DocumentVersionORM } from 'src/types/orms';

// Enum for document status types
export enum DocumentStatusType {
  AUTO_UPDATED = 'AUTO_UPDATED',
  MANUAL_UPDATED = 'MANUAL_UPDATED',
  NOT_AVAILABLE = 'NOT_AVAILABLE'
}

export const STATUS_MESSAGES = {
  [DocumentStatusType.AUTO_UPDATED]: {
    badges: [
      {
        text: 'AUTO UPDATED',
        appearance: 'outline',
        status: 'success',
      },
    ],
  },
  [DocumentStatusType.MANUAL_UPDATED]: {
    badges: [
      {
        text: (changeType: string) => changeType === 'major' ? 'MAJOR CHANGES' : 'MINOR CHANGES',
        appearance: 'outline',
        status: 'warning',
      },
    ],
  },
  [DocumentStatusType.NOT_AVAILABLE]: {
    badges: [
      {
        text: 'NO LONGER AVAILABLE',
        appearance: 'outline',
        status: 'danger',
      },
    ],
  },
}

export const getDocumentStatusType = (
  documentVersionORM: DocumentVersionORM | undefined,
  updates: DocumentVersionUpdateInfo[],
): DocumentStatusType => {
  if (!documentVersionORM) {
    return DocumentStatusType.NOT_AVAILABLE
  }

  return updates[0]?.status === FolderItemStatus.AutoUpdated
    ? DocumentStatusType.AUTO_UPDATED
    : DocumentStatusType.MANUAL_UPDATED
}

export const getBadgeText = (
  badge: { text: string | ((changeType: string) => string) },
  changeType: string,
): string => {
  return typeof badge.text === 'function' ? badge.text(changeType) : badge.text
}
